import { customElement, queryAssignedElements, state } from 'lit/decorators.js';
import { LitElement, html } from 'lit';
import CookieLayer from "@/components/cookie-layer/cookie-layer";
import '@/components/cookie-overlay/cookie-overlay'
import { linkedinPostStyles } from "@/components/linkedin-post/linkedin-post.styles.ts";
import { ClassInfo, classMap } from "lit/directives/class-map.js";

// eslint-disable-next-line
declare const TYPO3: any;

@customElement('sbk-linkedin-post')
export class SbkLinkedinPost extends LitElement {

    @queryAssignedElements({ selector: 'iframe' })
    _iframes!: Array<HTMLElement>;

    @state()
    cookiesAccepted: boolean;

    @state()
    expanded: boolean = false;

    constructor() {
        super();
        this.cookiesAccepted = CookieLayer.isCookieConsentLoaded();
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
    }
    disconnectedCallback() {
        document.removeEventListener('third-party-cookies-accepted', this._onCookiesAccepted);
        super.disconnectedCallback();
    }

    render() {
        if (!this.cookiesAccepted) {
            return html`
            <sbk-cookie-overlay></sbk-cookie-overlay>
        `;
        }
        return html`
            <div class=${classMap(this.getClassMap())}>
                <slot></slot>
                ${this.renderShowMoreButton()}
                ${this.renderShowLessButton()}
            </div>
        `;
    }

    renderShowMoreButton() {
        if (this.expanded === true) {
            return '';
        }
        return html`
            <div class="show-more">
                <sbk-button variant="secondary" @click=${this._showMore}>${this.getMessage('showMore')}</sbk-button>
            </div>
        `;
    }

    renderShowLessButton() {
        if (this.expanded === false) {
            return '';
        }
        return html`
            <div class="show-less">
                <sbk-button variant="secondary" @click=${this._showLess}>${this.getMessage('showLess')}</sbk-button>
            </div>
        `;
    }

    static get styles() {
        return [linkedinPostStyles];
    }

    private _showMore = () => {
        this.expanded = true;
    }

    private _showLess = () => {
        this.expanded = false;
    }

    _onCookiesAccepted = () => {
        this.cookiesAccepted = true;
    }

    getClassMap(): ClassInfo {
        return {
            'linkedin-post': true,
            [`linkedin-post--expanded`]: this.expanded,
        };
    }

    private getMessage(key: string): string {
        return typeof TYPO3 !== "undefined" ? TYPO3.lang[key] : key;
    }
}
